import { FormattedMessage } from 'react-intl';

interface BasePanelProps {
    thresholdClass?: string;
    testId?: string;
    subTitleKey?: string;
    children: React.ReactNode;
}

const BasePanel = ({ thresholdClass = '', testId, subTitleKey, children }: BasePanelProps) => (
    <div
        data-testid={testId}
        className="panel panel-default panel-body display-flex margin-bottom-5 width-100pct position-relative"
    >
        <div
            className={thresholdClass ? `bg-${thresholdClass}` : ''}
            style={{ width: '6px', margin: '-16px', flexShrink: 0 }}
        />
        <div className="width-100pct margin-left-25">
            <h5
                className={
                    'margin-top-0 margin-bottom-5 padding-bottom-1 ' +
                    'overflow-hidden white-space-nowrap text-overflow-ellipsis text-normal'
                }
                style={{ fontFamily: 'inherit' }}
            >
                <FormattedMessage id="intl-msg:engineOil.title" />
                {subTitleKey && (
                    <>
                        {' ('}
                        <FormattedMessage id={subTitleKey} />
                        {')'}
                    </>
                )}
            </h5>
            {children}
        </div>
    </div>
);

export default BasePanel;
